import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams
} from '@angular/common/http';

import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
  providedIn: 'root'
})
export class UpdateService {
  private readonly gitBaseUrl:string = environment.gitLab.url;
  private readonly headerToken: string = environment.gitLab.headerToken;
  private readonly headerType: string = environment.gitLab.headerType;
  private readonly apiBaseUrl:string = `${environment.baseUrl}${environment.baseApi}`;

  constructor(
    private readonly http: HttpClient
  ) { }

  public getLastGitMerge(): Observable<any> {
    const url = `${this.apiBaseUrl}sysupdate/git`;
    const headers = new HttpHeaders().set(this.headerType,this.headerToken);
    const params = new HttpParams().set('url',this.gitBaseUrl).set('token',this.headerToken);
    return this.http.get<any>(url,{headers,params});
  }

  public save(data:ISysUpdate): Observable<ISysUpdate>{
    const url = `${this.apiBaseUrl}sysupdate`;
    const headers = new HttpHeaders().set('Content-Type','application/json');
    return this.http.post<ISysUpdate>(url,data, {headers});
  } 

  public getLastUpdate(): Observable<ISysUpdate>{
    const url = `${this.apiBaseUrl}sysupdate`;
    const headers = new HttpHeaders().set('Content-Type','application/json');
    return this.http.get<ISysUpdate>(url,{headers});
  }

  public launchUpdate(data:IJenkinsData):Observable<ISysUpdate>{
    const url = `${this.apiBaseUrl}sysupdate/update`;
    const headers = new HttpHeaders().set(this.headerType,this.headerToken);
    return this.http.post<any>(url,data,{headers});
  }
}


export interface ISysUpdate{
  id ?: string;
  description ?: string;
  date ?: number;
  implemented ?: boolean;
  sourceBranch ?: string;
  targetBranch ?: string;
  user ?: string
  createdAt ?: number;
  updatedAt ?: number;
  type: SysUpdateEnum;
}

export enum SysUpdateEnum{
  PRIMEIRO_REGISTRO,
  REGISTRO,
}

export interface IJenkinsData{
  urlApi ?: string;
  urlView ?: string;
  user ?: string;
  password ?: string;
  environment ?: string;
  sysUser ?: string;
  targetBranch ?: string;
  sourceBranch ?: string;
  description ?: string;
}